import {useState, useEffect, useCallback} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const useSubscriptionStatusHandler = () => {
	const [message, setMessage] = useState(null);
	const navigate = useNavigate();
	const location = useLocation();

	const clearMessage = useCallback(() => {
		setMessage(null);
	}, []);

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const subscriptionStatus = queryParams.get("status");

		let timeout;

		if (subscriptionStatus) {
			switch (subscriptionStatus) {
				case "success":
					setMessage("Your subscription has been activated successfully.");
					timeout = setTimeout(() => {
						navigate("/app/applications", { replace: true });
						setMessage(null);
					}, 2000);
					break;
				case "error":
					setMessage("Failed to activate subscription. Please try again later.");
					timeout = setTimeout(() => {
						navigate(location.pathname, { replace: true });
						setMessage(null);
					}, 2000);
					break;
				case "cancelled":
					setMessage("Your subscription request has been cancelled.");
					timeout = setTimeout(() => {
						navigate(location.pathname, { replace: true });
						setMessage(null);
					}, 2000);
					break;
				default:
					setMessage("An error occurred during subscription. Please try again later.");
					timeout = setTimeout(() => {
						navigate(location.pathname, { replace: true });
						setMessage(null);
					}, 2000);
			}

			return () => {
				if (timeout) {
					clearTimeout(timeout);
				}
			};
		}

		return () => {
			if (timeout) {
				clearTimeout(timeout);
			}
		};

	}, [location.search, navigate, location.pathname]);

	return { message, clearMessage };
};
